"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffsetAsNumber = getOffsetAsNumber;
exports.getTokenKeyEnum = getTokenKeyEnum;
var _globalTokens = require("./global-tokens");
/*
 * The offset uses the global tokens that include a "px" postfix - not compatible with some components like the aria popover that require a number */
function getOffsetAsNumber(globalGapKey) {
  var offsetPixels = globalGapKey ? _globalTokens.globalGap[globalGapKey] : _globalTokens.globalGap.l;
  return Number(offsetPixels.replace('px', ''));
}
function getTokenKeyEnum(tokenObject) {
  return Object.keys(tokenObject).reduce(function (acc, key) {
    return _objectSpread({}, acc, _defineProperty({}, key, key));
  }, {});
}